import { render, staticRenderFns } from "./widget-user.vue?vue&type=template&id=ae1a3bda&scoped=true"
import script from "./widget-user.vue?vue&type=script&lang=js"
export * from "./widget-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1a3bda",
  null
  
)

export default component.exports